var _defs, _line, _path, _line2, _path2, _line3, _polygon, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.43 113.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-5{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke:#bca184;stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3{stroke-linecap:round;stroke-width:0.89px;}.cls-2{stroke-dasharray:0 1.96;}.cls-3{stroke-dasharray:0 1.96;}.cls-4{fill:#bca184;stroke-width:0.59px;}.cls-5{stroke-width:1.19px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.89,
    y1: 55.33,
    x2: 105.89,
    y2: 55.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.51,53.94c-7.14-7.16-39.8-39.82-45-45"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 58.85,
    y1: 8.26,
    x2: 58.85,
    y2: 8.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.47,9.64l-45,45"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.8,
    y1: 55.31,
    x2: 11.8,
    y2: 55.31
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "11.8 55.33 58.85 105.25 105.9 55.33 58.85 100.1 11.8 55.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.86,52.41H65.5c1-2.6-.52-5.52-2.84-6.83-4.78-2.9-11.17.8-12.26,6C48,62.13,60.17,69.21,69,64.11c7.77-4,9.92-14.44,5.65-21.79-10.79-16.82-35.19-8-35.76,11.18-.51,10.82,7.89,20.87,18.4,23,19.63,4,35.5-15.32,29.57-34-7.93-24.6-40.78-27-54.2-5.74C22,53.51,29.18,76.21,46.89,84.71a35.79,35.79,0,0,0,25.72,2.05c8.5-2.47,4.55-3.3,4.55-3.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/LOGO-01.d386761013fe2f14c2df5a0068bbe618.svg";
export { ForwardRef as ReactComponent };